import {
    MaybeComputedElementRef,
    tryOnMounted,
    unrefElement,
} from "@vueuse/core"
import { onMounted } from "vue"

export const useBigUnderlineEffect = (target: MaybeComputedElementRef) => {
    onMounted(() => {})

    tryOnMounted(() => {
        const ele = unrefElement(target)

        if (!ele) return
        // Sélectionne TOUS les éléments avec la classe 'big-underline'
        const bigUnderlines = ele.querySelectorAll(".big-underline")

        // Crée un observer
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("animate")
                    } else {
                        entry.target.classList.remove("animate")
                    }
                })
            },
            {
                threshold: 0.5, // Déclenche quand 50% de l'élément est visible
            }
        )

        // Observe chaque élément
        bigUnderlines.forEach((el) => observer.observe(el))
    })
}
